import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Currency } from '@app/model/currency';

@Component({
  selector: 'app-de-checkout-success',
  templateUrl: './de-checkout-success.component.html',
  styleUrls: [
    '../../../../route/page-shared.css',
    './de-checkout-success.component.scss',
  ],
})
export class DeCheckoutSuccessComponent {
  @Input() amount: Currency;
  @Input() email: string;
  @Input() paymentMethodString: string;

  readonly APP_STORE_LINK = 'https://apps.apple.com/de/app/id1560858500';
  readonly PLAY_STORE_LINK =
    'https://play.google.com/store/apps/details?id=io.zaver.app';

  @Output() onDetailsClick = new EventEmitter();

  ngOnInit(): void {}

  detailsClick() {
    this.onDetailsClick.emit();
  }

  openTab(url: string): void {
    window.open(url);
  }
}
